module.exports = __webpack_public_path__ + "static/media/download-solid-blue.f1ecbc46.svg";